import { StateCreator } from 'zustand'

import { checkClaimsWeb, IResponse, spError } from '@eventr/common'
import { EventrGatewayAPI } from '../../../data/gateway.api'
import { BoundStore } from '../../../state/bound.store'

interface AccessRequestState {
    accessRequests: any[]
}

interface AccessRequestActions {
    acceptRequest: (requestID: string) => Promise<IResponse<any>> //can this be undefined or should it be set to an empty string if it doesnt exist, for now setting to empty string
    loadRequests: () => Promise<void>
    rejectRequest: (
        requestID: string,
        reason: string
    ) => Promise<IResponse<any>>
}

export interface AccessRequestSlice
    extends AccessRequestState,
    AccessRequestActions { }

export const createAccessRequestSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    AccessRequestSlice
> = (set, get) => ({
    accessRequests: [],

    acceptRequest: async (requestID: string) => {

        return await EventrGatewayAPI.requestAccess.approveRequest(
            requestID,
            get().selectedOrg?.name ?? ''
        )
    },
    loadRequests: async () => {
        try {
            if (
                !checkClaimsWeb(['/'], ['editItinerary']) ||
                !get().selectedOrg
            ) {
                return
            }
            const resp = await EventrGatewayAPI.requestAccess.get()
            if (resp.status === 'success') {
                const filteredOrg = resp.data.filter(
                    (x: { orgID: string | undefined }) => x.orgID === get().selectedOrg?.name
                )
                const filteredRej = filteredOrg[0]?.requests.filter(
                    (x: { status: string }) => x.status !== 'rejected' && x.status !== 'approved'
                )
                set(
                    { accessRequests: filteredRej ?? [] },
                    false,
                    'loadAccessRequests'
                )
            }
        } catch (error) {
            spError('Failed to loadRequests', error)
        }
    },
    rejectRequest: async (requestID: string, reason: string) => {
        return await EventrGatewayAPI.requestAccess.rejectRequest(
            requestID,
            get().selectedOrg?.name ?? '',
            reason
        )
    },
})

// subscriptions to the store
